"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delegateProxy = void 0;

var _proxy = require("./../../proxy");

const delegateProxy = elements => class BasisTheoryProxyElementsDelegate extends _proxy.BasisTheoryProxy {
  get(options) {
    if (elements !== undefined) {
      return elements.proxy.get(options);
    }

    return super.get(options);
  }

  post(options) {
    if (elements !== undefined) {
      return elements.proxy.post(options);
    }

    return super.post(options);
  }

  put(options) {
    if (elements !== undefined) {
      return elements.proxy.put(options);
    }

    return super.put(options);
  }

  patch(options) {
    if (elements !== undefined) {
      return elements.proxy.patch(options);
    }

    return super.patch(options);
  }

  delete(options) {
    if (elements !== undefined) {
      return elements.proxy.delete(options);
    }

    return super.delete(options);
  }

};

exports.delegateProxy = delegateProxy;